import { render, staticRenderFns } from "./DeletePhotoButton.vue?vue&type=template&id=6c0c6264&scoped=true"
import script from "./DeletePhotoButton.vue?vue&type=script&lang=js"
export * from "./DeletePhotoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c6264",
  null
  
)

export default component.exports